import { Planzone, Identifiable, CostProfile } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";

function saveCostProfile(httpClient: HttpClient) {
  return (planzone: Identifiable<Planzone>, costProfile: CostProfile) =>
    httpClient.sendHttpRequest<Identifiable<CostProfile>>({
      endpoint: "/costProfiles/create",
      method: HttpMethods.POST,
      data: {
        ...costProfile,
        planzone: `planzones/${planzone.uuid}`,
      },
    });
}

export { saveCostProfile };
